// P1D-5531 (LLD §5.4). A near-by URL with no parsable point must not send `locality=near-by-…`
// to /api/v1/inventories as a literal filter. When isNearbyPage && !isNearbyRequest, drop
// `locality`, and a `locality_canonical_name` taken from it, so a shared link shows the region's
// normal search; otherwise return params unchanged.
export const stripNearbyLocalityWithoutPoint = (
  params: Record<string, any>,
  isNearbyPage: boolean,
  isNearbyRequest: boolean,
): Record<string, any> => {
  if (!isNearbyPage || isNearbyRequest) return params;
  const isNearBy = (value: unknown) => typeof value === "string" && value.includes("near-by");
  const next = { ...params };
  if (isNearBy(next.locality)) delete next.locality;
  if (isNearBy(next.locality_canonical_name)) delete next.locality_canonical_name;
  return next;
};

export default stripNearbyLocalityWithoutPoint;
